import { render, staticRenderFns } from "./QuitarTab.vue?vue&type=template&id=5ead67b1"
import script from "./QuitarTab.vue?vue&type=script&lang=js"
export * from "./QuitarTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports